import { CalendarRange, ClipboardList, FileText, Send, Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import Reveal from "@/components/landing/Reveal";

export default function HowItWorks() {
  const { t } = useTranslation();
  const steps = [
    {
      icon: Users,
      num: "1",
      title: t("landing.howItWorks.items.project.title"),
      desc: t("landing.howItWorks.items.project.desc"),
    },
    {
      icon: ClipboardList,
      num: "2",
      title: t("landing.howItWorks.items.ticket.title"),
      desc: t("landing.howItWorks.items.ticket.desc"),
    },
    {
      icon: Send,
      num: "3",
      title: t("landing.howItWorks.items.approval.title"),
      desc: t("landing.howItWorks.items.approval.desc"),
    },
    {
      icon: CalendarRange,
      num: "4",
      title: t("landing.howItWorks.items.schedulePayments.title"),
      desc: t("landing.howItWorks.items.schedulePayments.desc"),
    },
    {
      icon: FileText,
      num: "5",
      title: t("landing.howItWorks.items.invoice.title"),
      desc: t("landing.howItWorks.items.invoice.desc"),
    },
  ];

  return (
    <section id="how-it-works" className="bg-background py-20 lg:py-28">
      <div className="container mx-auto px-4 lg:px-8">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="text-3xl font-bold text-primary md:text-4xl">{t("landing.howItWorks.title")}</h2>
            <p className="mt-4 text-lg text-muted-foreground">{t("landing.howItWorks.subtitle")}</p>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-5">
          {steps.map((step, index) => (
            <Reveal key={step.num} delayMs={index * 120}>
              <div className="text-center">
                <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10">
                  <step.icon className="h-7 w-7 text-accent" />
                </div>
                <div className="mb-2 text-xs font-bold uppercase tracking-widest text-accent">{t("landing.howItWorks.stepLabel", { number: step.num })}</div>
                <h3 className="text-xl font-semibold text-primary">{step.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
